@if (activatedColor$ | async; as activatedColorCode) {
  <div class="container">
    @for (color of availableColors; track color; let i = $index) {
      <div
        (click)="selectColor(color.color)"
        class="mat-icon-wrapper"
        >
        <div
          class="selection"
            [ngClass]="{
                active: color.color === activatedColorCode,
            }"
          [ngStyle]="{ 'border-color': color.color }"
          >
          <div
            class="color"
            [ngStyle]="{ 'background-color': color.color }"
            >
            &nbsp;
          </div>
        </div>
      </div>
    }
  </div>
}
